import React, { useCallback } from 'react';

import AutoCompleteDropdown from 'components/uiLibrary/FormInputs/BaseComponents/AutoCompleteDropdown';
import Typography from 'components/uiLibrary/Typography';

import CommonTrans from 'components/Globals/CommonTrans';

import { AGGREGATION_TYPES, TP } from 'constants/index';

import { useAppliedCountryFilter } from 'utils/hooks/useLocationFilter';

import globalQueries from 'containers/Globals/queries';
import prodQueries from 'containers/Productions/queries';

import { useTranslation } from 'src/i18n';

const Label = ({ label, variant }) => {
  if (!variant) {
    return label;
  }

  return (
    <Typography variant={variant} size="12" truncate>
      <CommonTrans i18nKey={label} ns="NS_APP_GLOBALS" />
    </Typography>
  );
};

const CountryDropdown = ({
  className,
  value,
  onChange,
  aggregationOn,
  aggregationFilters,
  isDisabled = false,
  onBlur,
  disablePortal = false,
  label = `${TP}.m_COUNTRY`,
  hideLabel = false,
  labelVariant,
  variant,
  fullWidth = false,
  error = false,
  helperText = '',
  placeholder,
}) => {
  const { t } = useTranslation('NS_APP_GLOBALS');
  const aggregationQuery = useCallback(
    props =>
      prodQueries.getAggregatedEntities({
        ...props,
        aggregationOn,
        aggregationType: AGGREGATION_TYPES.COUNTRY,
        filters: aggregationFilters,
      }),
    [aggregationFilters, aggregationOn],
  );

  const { data: country } = useAppliedCountryFilter(value);

  return (
    <AutoCompleteDropdown
      className={className}
      value={country}
      onChange={onChange}
      onBlur={onBlur}
      searchQuery={globalQueries.getCountries}
      {...(aggregationOn && { aggregationQuery })}
      isDisabled={isDisabled}
      disablePortal={disablePortal}
      variant={variant}
      {...(!hideLabel && {
        label: <Label label={label} variant={labelVariant} />,
      })}
      textFieldProps={{
        ...(hideLabel && {
          placeholder: t(label),
        }),
      }}
      fullWidth={fullWidth}
      error={error}
      helperText={helperText}
      placeholder={placeholder}
    />
  );
};

export default CountryDropdown;
